import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
    constructor(private router: Router, private toastr: ToastsManager) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {

                }
                return event;
            })
            .catch((err: any, caught) => {



                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401 || err.status === 403) {
                        this.router.navigate(['/login']);
                    } else if (err.statusText === 'Unknown Error') {
                        this.toastr.error('مشکلی در ارتباط با شبکه رخ داده است', 'خطا');

                    }
                    return Observable.throw(err);
                }

            });
    }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/HttpInterceptor.ts